import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import Link from "next/link";

import Button from "components/Button";

export default function SubmitTip({ className, submitTips }) {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const regex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;

  return (
    <div className={className}>
      <Button
        className="flex items-center mx-1 sm:my-0"
        emphasis="primary"
        height="32"
        onClick={onOpenModal}
      >
        Submit a Tip
      </Button>
      <Modal
        classNames={{
          modal: "modal-submit-tip",
        }}
        open={open}
        onClose={onCloseModal}
        center
      >
        <h3 className="mt-8 px-4 text-2xl">Submit A Tip</h3>
        <ul className="mb-8 px-4">
          {submitTips.map((tip) => {
            const { name, email, url, phone_number } = tip;

            const strippedPhone = phone_number
              ? phone_number.replace(regex, "")
              : null;
            return (
              <li className="mt-8" key={name}>
                {name && <h3 className="font-semibold mb-2 text-xl">{name}</h3>}
                {email && (
                  <Link href={`mailto:${email}`}>
                    <a className="block">{email}</a>
                  </Link>
                )}
                {url && (
                  <Link href={url}>
                    <a className="block font-semibold mb-2 text-red">
                      View Website
                    </a>
                  </Link>
                )}
                {strippedPhone && (
                  <Link href={`tel:${strippedPhone}`}>
                    <a className="block">{phone_number}</a>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </Modal>
    </div>
  );
}
